// Version : 0.0.1
// Author : SABARI

import { docodeHexResponse } from '../../_common/common.utils';
import TransferBranchTypes from './transfer-branch.types';

const INITIAL_STATE = {
	// Add Duplicate Center Resposne
	addDuplicateCenterGroupResp: null,

	// Transfer Branch Center Resposne
	addBranchToCenterResponse: null,

	// Transfer Member Resposne
	transferMemberListResponse: null,

	// Transfer Member Array
	transferMemberListArr: [],

	// Transfer Center List Response
	transferCenterListResponse: null,

	// Transfer Center List Array
	transferCenterListArr: [],
};

const transferBranchReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************** CREATE DUPLICATE CENTER GROUP START ******************/
		case TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_SUCCESS:
			return {
				...state,
				addDuplicateCenterGroupResp: action.payload,
			};

		case TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_FAILURE:
			return {
				...state,
				addDuplicateCenterGroupResp: action.payload,
			};

		case TransferBranchTypes.CREATE_DUPLICATE_CENTER_GROUP_RESPONSE_CHANGED:
			return { ...state, addDuplicateCenterGroupResp: null };

		/************** CREATE DUPLICATE CENTER GROUP END ******************/

		/************** MEMBER BRANCH TO CENTER TRANSAFER START ******************/
		case TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_SUCESS:
			return {
				...state,
				addBranchToCenterResponse: action.payload,
			};

		case TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_FALIURE:
			return {
				...state,
				addBranchToCenterResponse: action.payload,
			};

		case TransferBranchTypes.MEMBER_BRANCH_TO_CENTER_TRANSAFER_RESPONSE_CHNAGED:
			return { ...state, addBranchToCenterResponse: null };

		/************** MEMBER BRANCH TO CENTER TRANSAFER END ******************/

		/************** TRANSFER MEMBER LIST START ******************/
		case TransferBranchTypes.TRANSFER_MEMBER_LIST_SUCCESS:
			return {
				...state,
				transferMemberListResponse: action.payload,
				transferMemberListArr: docodeHexResponse(action.payload, 'GetMemberListKey'),
			};

		case TransferBranchTypes.TRANSFER_MEMBER_LIST_FAILURE:
			return {
				...state,
				transferMemberListResponse: action.payload,
			};

		case TransferBranchTypes.TRANSFER_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, transferMemberListResponse: null };
		/************** TRANSFER MEMBER LIST END ******************/

		/************** FETCH TRANSFER CENTER LIST START ******************/
		case TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_SUCCESS:
			return {
				...state,
				transferCenterListResponse: action.payload,
				transferCenterListArr: docodeHexResponse(action.payload, 'GetAllCentersList'),
			};

		case TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_FAILURE:
			return {
				...state,
				transferCenterListResponse: action.payload,
			};

		case TransferBranchTypes.FETCH_TRANSFER_CENTER_LIST_RESPONSE_CHANGED:
			return { ...state, transferCenterListResponse: null };
		/************** FETCH TRANSFER CENTER LIST END ******************/

		default:
			return state;
	}
};
export default transferBranchReducer;
